export default __webpack_public_path__ + "static/media/Item Upload_Dark2.f3bab291.svg";